import React from "react";
import Modal from "../elements/Modal";

const SponsorModal = ({
	isOpenSponsor,
	setIsOpenSponsor,
	selectedSponsor,
	onSelectHorse,
}) => {
	if (!selectedSponsor) {
		return (
			<Modal isOpen={isOpenSponsor} className="Modal__sponsor-container">
				<div className="sponsor-modal">
					<div className="sponsor-modal__content center">
						<p>Loading sponsor information...</p>
					</div>
				</div>
			</Modal>
		);
	}
	return (
		<Modal isOpen={isOpenSponsor} className="Modal__sponsor-container">
			<div className="sponsor-modal">
				<div className="sponsor-modal__header">
					<p className="left">Sponsor</p>
					<div
						className="sponsor-modal__close"
						onClick={() => setIsOpenSponsor(false)}
					>
						<i className="fa fa-times"></i>
					</div>
				</div>

				<div className="sponsor-modal__content">
					<div className="center">
						<img
							src={selectedSponsor.logo}
							alt={selectedSponsor.name}
							className="sponsor-modal__logo"
						/>
						<a href={selectedSponsor.url}>
							<h2 className="sponsor-modal__title">
								{selectedSponsor.name}
							</h2>
						</a>
					</div>

					<h3 className="sponsor-modal__subtitle">
						About the Sponsor
					</h3>
					<p className="sponsor-modal__description">
						{selectedSponsor.promotional_text}
					</p>

					<h3 className="sponsor-modal__subtitle">
						Sponsored horses
					</h3>
					{selectedSponsor.horses &&
					selectedSponsor.horses.length > 0 ? (
						<div className="sponsor-modal__horses">
							{selectedSponsor.horses.map((horse) => (
								<button
									type="button"
									className="sponsor-modal__horse outline"
									key={horse.id}
									onClick={() => onSelectHorse(horse)}
								>
									{horse.display_name}
								</button>
							))}
						</div>
					) : (
						<p>No sponsored horses at the moment</p>
					)}
				</div>
			</div>
		</Modal>
	);
};

export default SponsorModal;
